import { AxiosError, AxiosResponse } from "axios";
import { axiosChartInstance } from "config";
import { useAxiosQuery } from "hooks";
import { UseQueryOptions } from "react-query";
import { TriageIvMedicationCountersResponse } from "./useIvAndMedicationCounters";

function useTreatmentsCounters(
  encounterId: string,
  options: UseQueryOptions<
    AxiosResponse<TriageIvMedicationCountersResponse>,
    AxiosError
  >
) {
  return useAxiosQuery(
    ["treatmentsCounters", { encounterId }],
    () =>
      axiosChartInstance.get<TriageIvMedicationCountersResponse>(
        `v1/triage/iv-medication/${encounterId}/treatments/counters`
      ),
    options
  );
}

export { useTreatmentsCounters };
